export default __webpack_public_path__ + "static/media/kumato-puttanesca-salad.0c44350c.jpg";